import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AppConfig } from 'src/app/config-service/app.config';

@Injectable({
  providedIn: 'root'
})
export class CookieManagementService {

  constructor(private cookieService: CookieService) { }

  setAccessToken(accessToken: string){
    try{
      let arSplitted = accessToken.split(".");
      if(arSplitted.length == 3){
        this.cookieService.delete('_hid');
        this.cookieService.delete('_uid');
        this.cookieService.delete('_sid');
        this.cookieService.delete('isLogin');
        this.cookieService.set('isLogin', 'true');
        this.cookieService.set('_hid', arSplitted[0]);
        this.cookieService.set('_uid', arSplitted[1]);
        this.cookieService.set('_sid', arSplitted[2]);
      }
      else{}
    }
    catch(err){}
  }

  getAccessToken():string{
    try{
      let accessToken = '';
      let hid = this.cookieService.get('_hid');
      let uid = this.cookieService.get('_uid');
      let sid = this.cookieService.get('_sid');
      
      if(hid != '' && uid != '' && sid != ''){
        accessToken = hid + '.' + uid + '.' + sid;
        return accessToken;
      }
      else{
        return '';
      }
    }
    catch(err){
      return '';
    }
  }

  setLanguage(lang: string){
    this.cookieService.set('lang', lang);
  }

  getlanguage():string{
    try{
      let defaultLang = AppConfig.settings.city.language;
      let lang = this.cookieService.get('lang');
      if(lang != ''){
        return lang;
      }
      else{
        let arSplitted = defaultLang.split('.');
        return arSplitted[0];
      }
    }
    catch(err){
      return '';
    }
  }

  isLogin():boolean{
    let isLogin = this.cookieService.get('isLogin');
    if(isLogin == 'true'){
      return true;
    }
    else{
      return false;
    }
  }

  logOut(){
    this.cookieService.delete('isLogin');
    this.cookieService.delete('_hid');
    this.cookieService.delete('_uid');
    this.cookieService.delete('_sid');
  }
}
